import React, { useState, useRef, useEffect } from 'react';
import { Grid, Box, Modal, LinearProgress, Typography, Checkbox, Button } from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import MuiSelect from "components/MuiSelect/MuiSelect";
import BulkUploadDataTable from "components/DataTable/BulkUploadDataTable";
import FileIcon from "assets/icons/FileIcon.svg";
import { Colors } from "assets/colors";
import Papa from 'papaparse';
import { styles as buttonStyle } from "common/inputStyles";
import { bulkUpload, getAllDeviceTypes } from "apis/device";
import SuccessModal from 'common/successModel';
import SampleCSVfile from "./DeviceImportSample.csv";


interface BulkUploadProps {
  open: boolean;
  handleClose: Function | any;
  fileTypes: Array<string>;
  getDeviceList: Function;
  setShowUpload: React.Dispatch<React.SetStateAction<boolean>>
}

const BulkUpload: React.FC<BulkUploadProps> = ({ open, handleClose, fileTypes, getDeviceList, setShowUpload }) => {
  const [currentFile, setCurrentFile] = useState<File | null>(null);
  const drop = useRef<HTMLInputElement>(null);
  const [borderStyle, setBorderStyle] = useState(`1px dashed ${Colors.Green}`);
  const [uploadType, setUploadType] = useState("");
  const [types, setTypes] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [error, setError] = useState("");
  const [tab, setTab] = useState(0);
  const [fileString, setFileString] = useState<any>(null);
  const [showsuccess, setShowsuccess] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (drop && drop.current) {
      console.log(drop.current)
      drop.current!.addEventListener('dragover', handleDragOver);
      drop.current!.addEventListener('drop', handleDrop);
      drop.current!.addEventListener('dragleave', handleDragLeave);
    }
  }, [drop, drop.current]);

  // handles grabbing data from csv and displaying a preview using DataTable
  useEffect(() => {
    if (currentFile !== null) {
      Papa.parse(currentFile, {
        header: true,
        dynamicTyping: true,
        complete: (results: any) => {
          if (results.data) {
            setPreviewData(results.data);
            setTab(1);
          }
        },
        error: (error: any) => {
          console.log(error);
        }
      });
    }
  }, [currentFile]);

  // grabs device types for dropdown
  useEffect(() => {
    const getDeviceTypes = async () => {
      let data = await getAllDeviceTypes();
      if (data?.response?.data?.errorMessage) {
        setError(data.response.data.errorMessage);
        return
      }
      if (data && data[0]) {
        setTypes(data);
        setUploadType(data[0].deviceTypeName);
      }
    }
    getDeviceTypes();
  }, []);

  const handleDragOver = (e: any) => {
    setBorderStyle(`2px solid ${Colors.Green}`);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e: any) => {   
    console.log("dragNLeave")
    setBorderStyle(`1px dashed ${Colors.Green}`);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
   //console.log(JSON.stringify(e.dataTransfer.files[0]))
    const file: File = e.dataTransfer.files[0];
  // const file: File = JSON.stringify(e.dataTransfer.files[0]);
    if (checkFileType(file)) {
      setCurrentFile(file);
    }
   //console.log(JSON.stringify(e.dataTransfer.files[0]))
  };
  const browseFileUpload = (e: any) => {
    const file: File = e.target.files[0];
    if (checkFileType(file)) {
      setCurrentFile(file);
    } else {
      setError("Incorrect File Type.")
    }
  };

  // checks if the file type is csv
  const checkFileType = (file: File) => {
    const extension = file.name.split(".").slice(-1)[0];
    return fileTypes?.includes(`.${extension}`);
  };

  // upload file to backend, #448
  const handleUpload = async () => {
    //console.log("clicked");
    setIsLoading(true);
    if (currentFile !== null) {
      let data = await bulkUpload(uploadType, currentFile);
       console.log(data);
      if (data?.response?.data?.errorMessage) {
        setError(data.response.data.errorMessage);
        return
      }
      if(data && data.rowList && data.rowList.length > 0) {
        let rows = data.rowList.map((r: any) => r.rowNum);
        let rowString = rows.join(',');
        setTimeout(getDeviceList(), 2000);
        setError(`${data.rowList[0].errorMsg}, rows: ${rowString}`);
        return
      }
      if(data && data.status) {
        setIsLoading(false);
        handleSuccess();
        setTimeout(handleclose, 2500);
        setTimeout(getDeviceList(), 2000);
         
        if(data.status === "success") {
          handleClose(false);  
        }
      }
    } else {
      setError("Upload a file.")
    }

  }
  useEffect(() => {
    getDeviceList();
  }, [])
 const reloadPage = () => {
  window.location.reload();
 }


 const handleSuccess = () => {
  setShowsuccess(true);
 }
 const handleclose = () => {
  setShowsuccess(false);
  setShowUpload(false);
 }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
      {isLoading && <LinearProgress />}
       {(currentFile !== null) ? <SuccessModal title='Success' open={showsuccess} /> : "" }
      <Box sx={styles.container}>
        <Grid item xs={12} sx={styles.header}>
          <h2>Device Bulk Upload</h2>
          <CloseIcon onClick={() => handleClose(false)} />
        </Grid>
        {error !== "" && <Typography sx={{ color: "red", fontSize: ".7rem" }}>{error}</Typography>}
        <Grid container spacing={2} sx={styles.actionHeader}>
          <Grid item xs={5}>
            <MuiSelect value={uploadType} options={types.map((t: any) => t.deviceTypeName)} onChangeHandler={(val: string) => setUploadType(val)} />
          </Grid>
          {tab === 1 &&
            <Grid item xs={2} sx={{ padding: "16px 0 0 16px" }}>
              <Button sx={{ ...buttonStyle.buttonGreen }} onClick={() => setTab(0)}>Change File</Button>
            </Grid>
          }

          <Grid item xs={2} display={"flex"} alignItems={"center"} sx={{ paddingLeft: "0" }}>
          <Button sx={styles.CSVDLoadBtn} href={SampleCSVfile} target="_blank" rel="noopener noreferrer" download>Download CSV Template</Button>
          </Grid>
        </Grid>
        {tab === 0 &&
          <>
            <Grid item xs={12}  sx={{ ...styles.uploadContainer, border: borderStyle, height: "20rem" }} ref={drop}>
              <img src={FileIcon} />
              <div style={styles.text}>
                Drag your file here, or
                <input type="file" className="custom-file-input" onChange={browseFileUpload} accept={fileTypes.join(",")} />
              </div>
            </Grid>
          </>
        }
        {tab === 1 &&
          <>
            <Grid item xs={12} sx={{ height: "20rem" }}>
              <BulkUploadDataTable data={previewData} />
            </Grid>
          </>

        }
        <Grid item xs={12} sx={styles.buttonContainer}>
          <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
          <Button sx={styles.addButton} onClick={handleUpload}>Upload</Button>
        </Grid>

      </Box>
      </>
    </Modal>
  )
}

export default BulkUpload;